import { render } from "./ReportNotification.vue?vue&type=template&id=6a85bd94&ts=true"
import script from "./ReportNotification.vue?vue&type=script&lang=ts"
export * from "./ReportNotification.vue?vue&type=script&lang=ts"

import "./ReportNotification.vue?vue&type=style&index=0&id=6a85bd94&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__